angular.module('CarsSaraBo').controller('CarController', ['$scope', '$routeParams','$q','FleetService','$http', '$location','GAService', 'SessionService', '$translate',
                                             function($scope, $routeParams,$q, fleetService,$http,$location, gaService, sessionService, translate) {
	 var MAX_LOCKED_CARD_AMOUNT = 5000;
	 var ID_COUNTRY_US = 20208;

	 function initialize() {
		$scope.showProgressBar();
		$scope.carSelected=null;
		$scope.carModelLogo="";
		loadCompany();
		loadData();
		$scope.errorMessages={};
		$scope.validations = {};
		$scope.validations.checkLockedCard=false;
		$scope.currencyCode = sessionService.session.currencyCode;
		$scope.companyOid = $routeParams.companyOid;
		$scope.countryOid = sessionService.session.countryOid;
	}

	function loadCompany(){
		if($routeParams.oid == "new"){
			$scope.hideProgressBar();
			return;
		}
		fleetService.getOne({companyOid: $routeParams.companyOid, oid:$routeParams.oid }, function(response) {
			$scope.carSelected= response;
			$scope.getLogo(response.carModel.picture.url);
			if($scope.carSelected.lockedCardAmount==0){
				$scope.validations.checkLockedCard=true;
			}
			$scope.hideProgressBar();
		});
	}

	function loadData(){
		 $http.get("../rest/data/brands/"+$routeParams.companyOid).success(function(response) {$scope.brands = response;});
		 $scope.transmisions=["M","A"];
		 $scope.doors=[2,3,4,5];
		 $scope.passengers=[2,3,4,5,6,7,8,9,10,11,12,13,14,15];
		 $scope.baggage=[0,1,2,3,4,5,6];
	}

	$scope.goBack = function() {
		var companyOid = $scope.companyOid;
		$location.path("/company/" +  companyOid + "/fleet");
	};

	$scope.cancel = function(){
		$scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function() {
			$scope.goBack();
		});

	};

	$scope.updateModels = function(brand){
        var companyOid = $scope.companyOid;
        $http.get("../rest/data/models/"+brand+"/"+companyOid).success(function(response) {$scope.models = response;});
	};

	$scope.search = function(){
		$scope.submitted=true;
		if(this.searchForm.$valid){
			$scope.brandModelDescription=true;
			fleetService.getOne({companyOid: $routeParams.companyOid, brand:this.brandSelected, model:this.modelSelected},
					function(response) {
			    gaService.notify("Autos_flota_de_vehiculos", "buscar_vehículo", [response.carModel.brand, response.carModel.model]);
				$scope.carSelected= response;
				$scope.getLogo(response.carModel.picture.url);
			});
		}
	};

	$scope.save = function(car){
        var deferred = $q.defer();
		$scope.errorField = {};
		if(validCar()) {
			if(!$scope.carSelected.oid){
				saveCar(car, deferred);
			} else {
				updateCar(car, deferred);
			}
		} else {
			deferred.reject();
		}
        return deferred.promise;
	};

	function saveCar(car, deferred){
		$scope.carSelected.companyOid=$routeParams.companyOid;

		if($scope.countryOid){
            $scope.carSelected.countryOid = $scope.countryOid;
		}else{
            $scope.carSelected.countryOid = JSON.parse(localStorage.getItem("company")).countryOid
		}

		fleetService.save({companyOid: $routeParams.companyOid},$scope.carSelected)
            .$promise
			.then(function(response) {
				gaService.notify("Autos_flota_de_vehiculos", "nuevo_vehículo", [response.acriss]);
				deferred.resolve();
				$scope.goBack();
				$scope.notifyInfoByCode('car.confirmationMessage.SUCCESS_SAVE');
			}, function (error) {
				deferred.reject();
                $scope.notifyErrorByCode("internalError.TITLE");
            });
	}

	function updateCar(car, deferred){
		$scope.carSelected.countryOid = $scope.countryOid;

	    fleetService.update({companyOid: $routeParams.companyOid, oid: $scope.carSelected.oid },$scope.carSelected)
            .$promise
            .then(function(response) {
				gaService.notify("Autos_flota_de_vehiculos", "editar_vehículo", [response.acriss]);
				deferred.resolve();
				$scope.goBack();
				$scope.notifyInfoByCode('car.confirmationMessage.SUCCESS_SAVE');
			});
	}

    $scope.goToCreateNewCarTemplate = function () {
	    $location.path("/company/" +  $scope.companyOid + "/carTemplate/add");
	}

	$scope.goToCarTemplateList = function () {
        $location.path("/company/" +  $scope.companyOid + "/carTemplate/picture/PENDING_IMAGE_UPDATE");
    }

	function validCar(){
		var error = {};
		var isValid = $scope.isValid(error);
		$scope.notifyFormErrors(error);
		return isValid;
	}

	function isLockedCardAmountInRange(){

		if(!$scope.validations.checkLockedCard && $scope.isCountryUS()){
			if(!$scope.carSelected.lockedCardAmount) {
				return false;
			}

			var lockedCardAmount = parseFloat($scope.carSelected.lockedCardAmount.replace(",","."));

			return (lockedCardAmount <= MAX_LOCKED_CARD_AMOUNT);
		}
		return true;
	}

	$scope.isCountryUS = function(){
		return (sessionService.session.countryOid === ID_COUNTRY_US);
	}

	$scope.isValid = function(error) {
	    var valid = true;

		if(!$scope.carSelected){
			return false;
		}
		if(!$scope.carSelected.name){
			error.required = true;
			$scope.errorField['carName']="input-error";
			valid = false;
		}else if($scope.carSelected.name.length<5){
			$scope.errorField['carName']="input-error";
			error.additionalErrors = ["fleet.carName.MIN_LENGHT"];
			valid = false;
		}else if($scope.carSelected.name.length > 30) {
			$scope.errorField['carName']="input-error";
			error.additionalErrors = ["fleet.carName.MAX_LENGHT"];
			valid = false;
		}
		if(!$scope.validTextField($scope.carSelected.name)) {
			$scope.errorField['carName']="input-error";
			error.additionalErrors = ["ERROR.common.INVALID_NAME"];
			valid = false;
        }
		if(!$scope.validAmountField($scope.carSelected.lockedCardAmount)) {
			error.invalidAmountFormat = true;
			$scope.errorField['lockedCardAmount']="input-error";
			valid = false;
		}
		if((!$scope.validations.checkLockedCard) && (!$scope.carSelected.lockedCardAmount || $scope.carSelected.lockedCardAmount==0)){
			error.required = true;
			$scope.errorField['lockedCardAmount']="input-error";
			valid = false;
		}

		//Verifying the max locked card amount
		if(!isLockedCardAmountInRange()){
			$scope.errorField['lockedCardAmount'] = "input-error";
			error.additionalErrors = ["fleet.message.LOCKED_CARD_AMOUNT_MAX"];
			valid = false;
		}

        return valid;
	}

	$scope.getLogo = function(file) {
		if(file){
			$scope.carModelLogo = file;
		}
	}

	initialize();
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/fleet_controllers/car_controller.js
// module id = 917
// module chunks = 3